import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import Datatable from '../controls/Datatable.jsx';
import SelectEvent from '../controls/SelectEvent.jsx';
import DatatablesCallbacks from '../../datatables/DatatablesCallbacks';
import '../../../resources/css/relatorio.css';
import Format from '../../utils/Formatter';

class CarrinhosPagos extends React.Component {

    render() {
        const app = this.props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.RELATORIO_CARRINHOS_PAGOS)
            return null;

        const token = this.props.token;
        const eventId = this.props.participants.selectedEvent ? this.props.participants.selectedEvent.id : null;

        const paymentColumns = this.props.caixa.pagamentos
            .map(p => ({data: p.id_forma_pagamento, title: p.descricao + " (R$)", render: $.datatable.renders.money(".", ",", 2)}));

        const datatablesColumns = [
            { data: "id", title: "ID", render: $.datatable.renders.text() },
            { data: "nome", title: "Cliente", render: $.datatable.renders.text() },
            { data: "cpf", title: "CPF", render: $.datatable.renders.text() },
            { data: "vendedor", title: "Vendedor", render: $.datatable.renders.text() },
            { data: "caixa", title: "Caixa", render: $.datatable.renders.text() },
        ].concat(paymentColumns)
        .concat([
            { data: "total", title: "Total (R$)", render: $.datatable.renders.money(".", ",", 2) },
            { data: "date", title: "Data", render: Format.dateTime },
        ]);

        let urlBase = '/api/reports/vendas';
        let callbacks = new DatatablesCallbacks({
            token: token,
            selectUrl: `${urlBase}?${$.param(_.pickBy({eventId}, _.identity))}`,
        });

        const buttons = [
            {
                extend: 'csv',
                text: 'download',
                fieldSeparator: ';',
                filename: 'CarrinhosPagos',
            },
        ];

        const domClassName = 'report-carrinhos-pagos-datatables';

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h2>Relatório de Carrinhos Pagos</h2>
                    </div>
                </div>

                <SelectEvent {...this.props}/>

                <Datatable DomClassName={domClassName}
                           title={null}
                           subTitle={null}
                           responsive={true}
                           pageLength={100}
                           buttons={buttons}
                           editorCreateVisible={false}
                           editorEditVisible={false}
                           editorRemoveVisible={false}
                           datatablesColumns={datatablesColumns}
                           datatablesSelect={callbacks.select.bind(callbacks)}
                />
            </div>
        );
    }
}

export default CarrinhosPagos;



// WEBPACK FOOTER //
// src/views/pages/RelatorioCarrinhosPagos.jsx